import locale77526775 from '../../lang/fr.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
}
export const nuxtOptions = {
  isUniversalMode: false,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"fr"},
  vueI18nLoader: true,
  locales: [{"code":"en","iso":"en","pubId":"41","name":"English","file":"en.js"},{"code":"fr","iso":"fr","pubId":"47","name":"Français","file":"fr.js"},{"code":"co","iso":"es-CO","pubId":"51","name":"Español (CO)","file":"es.js"},{"code":"mx","iso":"es-MX","pubId":"53","name":"Español (MX)","file":"es.js"},{"code":"ar","iso":"es-AR","pubId":"50","name":"Español (AR)","file":"es.js"},{"code":"nl","iso":"nl","pubId":"42","name":"Nederlands","file":"nl.js"},{"code":"it","iso":"it","pubId":"45","name":"Italiano","file":"it.js"},{"code":"pt","iso":"pt","pubId":"46","name":"Portugués","file":"pt.js"},{"code":"es","iso":"es-ES","pubId":"43","name":"Español","file":"es.js"},{"code":"de","iso":"de","pubId":"44","name":"Deutsch","file":"de.js"}],
  defaultLocale: "fr",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix",
  lazy: true,
  langDir: "/app/lang",
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: false,
  seo: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncLocale":false,"syncMessages":false,"syncRouteParams":true},
  parsePages: false,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  beforeLanguageSwitch: () => null,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  domain: "www.nh-hotels.com",
  routes: {},
  normalizedLocales: [{"code":"en","iso":"en","pubId":"41","name":"English","file":"en.js"},{"code":"fr","iso":"fr","pubId":"47","name":"Français","file":"fr.js"},{"code":"co","iso":"es-CO","pubId":"51","name":"Español (CO)","file":"es.js"},{"code":"mx","iso":"es-MX","pubId":"53","name":"Español (MX)","file":"es.js"},{"code":"ar","iso":"es-AR","pubId":"50","name":"Español (AR)","file":"es.js"},{"code":"nl","iso":"nl","pubId":"42","name":"Nederlands","file":"nl.js"},{"code":"it","iso":"it","pubId":"45","name":"Italiano","file":"it.js"},{"code":"pt","iso":"pt","pubId":"46","name":"Portugués","file":"pt.js"},{"code":"es","iso":"es-ES","pubId":"43","name":"Español","file":"es.js"},{"code":"de","iso":"de","pubId":"44","name":"Deutsch","file":"de.js"}],
  localeCodes: ["en","fr","co","mx","ar","nl","it","pt","es","de"],
}

export const localeMessages = {
  'fr.js': () => Promise.resolve(locale77526775),
  'en.js': () => import('../../lang/en.js' /* webpackChunkName: "lang-en.js" */),
  'es.js': () => import('../../lang/es.js' /* webpackChunkName: "lang-es.js" */),
  'nl.js': () => import('../../lang/nl.js' /* webpackChunkName: "lang-nl.js" */),
  'it.js': () => import('../../lang/it.js' /* webpackChunkName: "lang-it.js" */),
  'pt.js': () => import('../../lang/pt.js' /* webpackChunkName: "lang-pt.js" */),
  'de.js': () => import('../../lang/de.js' /* webpackChunkName: "lang-de.js" */),
}
